<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "../components/loader";
import blingLogo from "@/assets/images/integracoes/bling_logo.png"
import tinyLogo from "@/assets/images/integracoes/tiny_logo.png"
import trayLogo from "@/assets/images/integracoes/tray_logo.webp"
import vindiLogo from "@/assets/images/integracoes/vindi_logo.svg"
import api from "@/axios";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
    name: "IntegracoesGeral",
    page: {
        title: "Integrações Geral",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
        // Loader,
    },
    data() {
        return {
            title: "Configurar Integrações",
            items: [
                {
                    text: "Integrações",
                    href: "/",
                },
                {
                    text: "Geral",
                    active: true,
                    },
            ],
            integrations: [
                {
                    hub: "BLING",
                    name: "Bling",
                    description: "Marketplace",
                    image: blingLogo,
                    status: false,
                    show: true,
                    data: {},
                },
                {
                    hub: "TINY",
                    name: "Tiny",
                    description: "Marketplace",
                    image: tinyLogo,
                    status: false,
                    show: true,
                    data: {},
                },
                {
                    hub: "TRAY",
                    name: "Tray",
                    description: "Marketplace",
                    image: trayLogo,
                    status: false,
                    show: true,
                    data: {},
                },
                {
                    hub: "YAPAY",
                    name: "Vindi",
                    description: "Marketplace",
                    image: vindiLogo,
                    status: false,
                    show: true,
                    data: {},
                },
            ],
            integrationModal: {
                show: false,
                index: 0,
                data: {},
            }
        };
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            console.log('loadData integrations geral')
            try {
                api.get(`${getBaseUrl()}api/integrationIndex`)
                .then((res) => {
                    console.log('then axios integrationIndex')
                    console.log(res.data)

                    if (res.data.length > 0) {
                        this.integrations.map(function(integration) {
                            let found = res.data.find(item => item.hub === integration.hub);
                            if (found) {
                                integration.status = true;
                                integration.data = found;
                            } else {
                                console.log('não encontrado', integration.hub)
                            }
                        });
                    }
                });
            } catch (error) {
                console.error("Error fetching integrations:", error);
            }
        },
        activateIntegration(index) {
            this.integrationModal.index = index
            this.integrationModal.data = {
                hub: this.integrations[index].hub
            }
  
            this.integrationModal.show = true
        },
        deleteIntegration(index) {
            Swal.fire({
                title: "Aviso!",
                text: "Esta ação é irreversível. Tem certeza que deseja desativar esta integração e deletar as informações registradas?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, desativar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    api.delete(`${getBaseUrl()}api/emprtoken`, {
                        params: {
                            'iddata': this.integrations[index].data.id
                        }
                    }).then(() => {
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "Informações deletadas com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        }).then(() => {
                            window.location.reload()
                        })
                    })
                }
            });
        },
        editIntegration(index) {
            this.integrationModal.index = index
            this.integrationModal.data = this.integrations[index].data
  
            this.integrationModal.show = true
        },
        confirmIntegration() {
            console.log('confToken')

            api.post(`${getBaseUrl()}api/emprtoken`, {
                empreTokemData: this.integrationModal.data
            }).then((res) => {
                console.log('then axios')
                console.log(res)
                this.showFormToken = false
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Informações salvas com sucesso!",
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    this.integrationModal.show = false
                    this.loadData()
                })
            }).catch((err) => {
                console.error('catch axios', err)
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Erro ao salvar as informações!",
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    this.integrationModal.show = false
                    this.loadData()
                })
            })
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <!-- <Loader v-if="updating" style="min-height: 400px;">
        </Loader> -->

        <b-container fluid class="mt-3">
            <b-row>
                <b-col
                    v-for="(integration, index) in integrations"
                    :key="index"
                    cols="12"
                    md="6"
                    lg="4"
                    class="mb-4"
                    v-show="integration.show"
                >
                    <b-card>
                        <b-row class="align-items-center">
                            <b-col cols="4" class="text-center">
                                <b-img
                                    :src="integration.image"
                                    alt="Integration Image"
                                    fluid
                                    class="mb-2"
                                ></b-img>
                            </b-col>
                            <b-col cols="8">
                                <h5>{{ integration.name }}</h5>
                                <p>{{ integration.description }}</p>
                            </b-col>
                        </b-row>
                        <b-row class="align-items-center"> 
                           <b-col cols="4" class="text-center">
                                <b-button 
                                    variant="outline-success"
                                    :disabled="integration.status"
                                    @click="activateIntegration(index)"
                                >   
                                    {{ integration.status ? "Integrado" : "Integrar" }}
                                </b-button>
                           </b-col>
                           <b-col cols="4" class="text-center" v-if="integration.status">
                                <b-button
                                    variant="outline-warning"
                                    @click="editIntegration(index)"
                                >
                                    Editar
                                </b-button>
                           </b-col>
                           <b-col cols="4" class="text-center" v-if="integration.status">
                                <!-- <b-form-checkbox
                                    id="periodoPesq"
                                    switch
                                    size="md"
                                    v-model="detalhedExibition"
                                    @change="mudouPeriodo"
                                >
                                    Desligar
                                </b-form-checkbox> -->
                                <b-button
                                    variant="outline-danger"
                                    @click="deleteIntegration(index)"
                                >
                                    Desativar
                                </b-button>
                           </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <b-modal  
            size="lg"
            v-model="integrationModal.show" 
            :title="
                integrations[integrationModal.index].status ? 
                'Configurar Integração' : 'Editar Integração'
            "
            centered hide-footer
        >
            <div class="row" id="div-principal">
                <div class="row" id="div-card">
                <div class="card-body" id="div-car-body">

                    <form class="needs-validation" v-if="!loadingEmprTokemData">
                    <div class="row">

                        <div class="col-sm-6">
                        <div class="mb-3">
                            <label for="validade">Validade (Dias)</label>
                            <input
                                id="validade"
                                v-model="integrationModal.data.validade"
                                type="number"
                                class="form-control"
                                placeholder="Validade"
                                readonly
                                />
                        </div>
                        </div>


                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="token">Token</label>
                            <input
                                id="token"
                                v-model="integrationModal.data.token"
                                type="text"
                                class="form-control"
                                placeholder="Token (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-6">
                        <div class="mb-3">
                            <label for="login">Login</label>
                            <input
                                id="login"
                                v-model="integrationModal.data.login"
                                type="text"
                                class="form-control"
                                placeholder="Login (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-6">
                        <div class="mb-3">
                            <label for="senha">Senha</label>
                            <input
                                id="senha"
                                v-model="integrationModal.data.senha"
                                type="text"
                                class="form-control"
                                placeholder="Senha (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="cliid">Client ID</label>
                            <input
                                id="cliid"
                                v-model="integrationModal.data.cliid"
                                type="text"
                                class="form-control"
                                placeholder="Client ID (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="clisecret">Client Secret</label>
                            <input
                                id="clisecret"
                                v-model="integrationModal.data.clisecret"
                                type="text"
                                class="form-control"
                                placeholder="Client Secret (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="codadmin">Cod. Administrativo</label>
                            <input
                                id="codadmin"
                                v-model="integrationModal.data.codadmin"
                                type="text"
                                class="form-control"
                                placeholder="Código administrativo (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="codloja">Código Loja</label>
                            <input
                                id="codloja"
                                v-model="integrationModal.data.codloja"
                                type="text"
                                class="form-control"
                                placeholder="Código da Loja (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="urlloja">URL Loja</label>
                            <input
                                id="urlloja"
                                v-model="integrationModal.data.urlloja"
                                type="text"
                                class="form-control"
                                placeholder="URL da Loja (caso haja)"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="actoken">Access Token</label>
                            <textarea
                                id="actoken"
                                v-model="integrationModal.data.actoken"
                                type="text"
                                rows="2"
                                :disabled="true"
                                class="form-control"
                                placeholder="Access Token"/>

                        </div>
                        </div>

                        <div class="col-sm-12">
                        <div class="mb-3">
                            <label for="rftoken" v-if="integrationModal.data.hub === 'CORREIOS'">Status Contrato</label>
                            <label for="rftoken" v-else>Refresh Token</label>
                            <textarea
                                id="rftoken"
                                v-model="integrationModal.data.rftoken"
                                type="text"
                                rows="4"
                                :disabled="true"
                                class="form-control"
                                placeholder="Refresh Token"/>

                        </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="text-end mt-5">
                            <b-button 
                                variant="outline-danger" 
                                @click="showFormToken = false"
                                v-if="integrations[integrationModal.index].status"
                            >
                                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                                Desfazer Integração
                            </b-button>
                            
                            <b-button 
                                variant="light" 
                                class="mx-2"
                                @click="integrationModal.show = false"
                            >
                                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                                Cancelar
                            </b-button>

                            <b-button 
                                type="button" 
                                variant="success" 
                                @click="confirmIntegration"
                            >
                                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                                Confirmar
                            </b-button>
                        </div>
                    </div>
                    </form>

                </div>
                </div>
            </div>
            </b-modal>
    </Layout>
</template>